'use client';
import React, { useState } from 'react';
import Head from 'next/head';
import Link from 'next/link';

const sections = [
      {
        title: "What Are Cookies?",
        content: "Cookies are small text files placed on your device (computer, smartphone, or other internet-enabled devices) when you visit our website. They help us recognize your device, remember your preferences, and enhance your browsing experience."
      },
      {
        title: "Why We Use Cookies",
        content: "We use cookies to:\n- Enable essential website functions (e.g., shopping cart, secure login)\n- Analyze traffic and user behavior through analytics tools\n- Deliver personalized ads and content\n- Remember user preferences and improve user experience\n- Ensure the security of our website"
      },
      {
        title: "Types of Cookies We Use",
        content: "1. **Essential Cookies**: These are required for the website to operate correctly. Without them, core features like product browsing, checkout, or user login may not function.\n2. **Performance & Analytics Cookies**: These help us measure website traffic and performance using tools like Google Analytics, so we can improve how our website works.\n3. **Functionality Cookies**: These remember your preferences (like language or region) and enhance your experience on our site.\n4. **Targeting & Advertising Cookies**: These are used to show you relevant ads across other platforms like Facebook or Google based on your browsing behavior on vilvabusiness.com."
      },
      {
        title: "Third-Party Cookies",
        content: "We may allow third-party services to place cookies on your device to help us:\n- Serve targeted advertisements\n- Provide integrated content (e.g., videos, chat support)\n- Collect anonymous usage data\n\nThese services include, but are not limited to:\n- Google Ads\n- Meta Pixel (Facebook/Instagram)\n- Payment gateways (e.g., Razorpay, Stripe)"
      },
      {
        title: "Managing Cookies",
        content: "You can choose to accept or decline cookies through your browser settings. Most browsers allow you to manage cookies in their settings or preferences menu. Browser controls include:\n- Chrome: chrome://settings/cookies\n- Firefox: about:preferences#privacy\n- Safari: https://support.apple.com/en-us/HT201265\n- Microsoft Edge: edge://settings/content/cookies\n\n**Note**: Disabling some cookies may impact your experience on our website."
      },
      {
        title: "Updates to This Cookie Policy",
        content: "We may update this policy from time to time to reflect changes in law, technology, or business operations. All updates will be posted on this page with an updated effective date."
      },
      {
        title: "Contact Us",
        content: "If you have any questions about our use of cookies, please contact us:\nEmail: info@vilvabusiness.com\nPhone: +91 9176569459"
      }
    ];

const Cookiepolicy = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleSection = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className=' bg-[linear-gradient(180deg,_#EEF3FF_0%,_#FFF_26.53%)]'>


      <div className="max-w-2xl mx-auto px-4 py-[50px] text-[#1f1f1f]">
        <h1 className="text-[color:var(--Dark-Color,#090D28)]  text-center mb-[40px] font-LatinkaBold text-[32px] md:text-[40px] not-italic font-normal leading-[120%]"> Cookie Policy</h1>
        <p className="text-[#373844] font-LatinkaRegular mb-[40px] text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">
At <strong>vilvabusiness.com</strong>, we are committed to protecting your privacy and ensuring transparency in how we collect and use data. This Cookie Policy explains how we use cookies and similar technologies on our website.
        </p>


        {sections.map((section, index) => (
          <div key={index}     className={`border-t py-[24px] ${index === sections.length - 1 ? 'border-b' : ''}`}>
            <div
              role="button"
              tabIndex={0}
              aria-expanded={openIndex === index}
              aria-controls={`cookie-panel-${index}`}
              onClick={() => toggleSection(index)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSection(index); } }}
              className="flex justify-between items-center cursor-pointer"
            >
              <h2 className="text-[color:var(--Dark-Color,#090D28)] font-LatinkaBold text-[20px] md:text-[24px] not-italic font-normal leading-[100%]">{section.title}</h2>
              <span aria-hidden="true" className="flex w-[32px] h-[32px] p-[6px] justify-center items-center aspect-square rounded-[6px] bg-[#EFF4FF]">
                {openIndex === index ? <svg className={`transform transition-transform duration-300 ${
      openIndex !== index ? 'rotate-0' : 'rotate-180'
    }`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M4.16602 10H15.8327" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg> : <svg className={`transform transition-transform duration-300 ${
      openIndex === index ? 'rotate-90' : 'rotate-0'
    }`} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M4.16602 10H15.8327" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 4.16667V15.8333" stroke="#195AFF" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>}
              </span>
            </div>

            <div
              id={`cookie-panel-${index}`}
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index ? 'max-h-[1000px] mt-2' : 'max-h-0'
              }`}
            >
              <p className="text-[#373844] font-LatinkaRegular text-[14px] md:text-[16px] not-italic font-normal leading-[150%]">{section.content}</p>
            </div>
          </div>
        ))}


<div className='mt-[80px] flex items-center justify-center gap-[16px] flex-wrap'>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-LatinkaMedium text-[14px] not-italic font-normal leading-[120%] !underline" href={'/privacy-policy'}>Privacy Policy</Link>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-LatinkaMedium text-[14px] not-italic font-normal leading-[120%] !underline" href={'/terms-and-condition'}>Other Policies</Link>
  <Link className="text-[color:var(--Main-colour,#195AFF)] font-LatinkaMedium text-[14px] not-italic font-normal leading-[120%] !underline" href={'/cookie-policy'}>Cookie Policy</Link>

</div>

        
      </div>

<div className='bg-[#01001E] py-[60px] md:py-[120px] flex items-center justify-center'>

<div>
  <h3 className="text-white font-LatinkaBold text-center text-[32px] md:text-[48px] not-italic font-normal leading-[120%]">Always <span className="text-transparent bg-[linear-gradient(90deg,_#15BDFF_20.57%,_#C05DF2_54.45%)] bg-clip-text font-LatinkaBold text-[32px] md:text-[48px] not-italic font-normal leading-[120%]"
>On Schedule </span>  always <span className="text-transparent mb-[16px] bg-[linear-gradient(90deg,_#15BDFF_20.57%,_#C05DF2_54.45%)] bg-clip-text font-LatinkaBold text-[32px] md:text-[48px] not-italic font-normal leading-[120%]"
>Reliable</span> </h3>

  <p className="text-[#DADAE4] text-center mb-[24px] font-LatinkaRegular text-[16px] md:text-[18px] not-italic font-normal leading-[150%]">Our team ensures timely results without compromising quality</p>

  <Link className="rounded-[8px] w-fit bg-[var(--Main-colour,#195AFF)] mx-auto flex h-[48px] px-[32px] py-[16px] justify-center items-center text-white font-LatinkaMedium text-[18px] not-italic font-normal leading-[120%]"
 href={'/book-demo'}> Book Free Demo </Link>
</div>
</div>

      </div>

    </>
  );
};

export default Cookiepolicy;
